import type { MessageKey } from 'types/LocaleMessageKey';

export interface InfoFeatureData {
  id: number;
  title: MessageKey;
  body: MessageKey;
}

export const membershipInfoFeaturesData: InfoFeatureData[] = [
  {
    id: 1,
    title: 'membership_features_workout_heart_rate_tracking_title',
    body: 'membership_features_workout_heart_rate_tracking_body',
  },
  {
    id: 2,
    title: 'membership_features_restorative_time_title',
    body: 'membership_features_restorative_time_body',
  },
  {
    id: 3,
    title: 'membership_features_sp02_title',
    body: 'membership_features_sp02_body',
  },
  {
    id: 4,
    title: 'membership_features_trends_title',
    body: 'membership_features_trends_body',
  },
  {
    id: 5,
    title: 'membership_features_rest_mode_title',
    body: 'membership_features_rest_mode_body',
  },
  {
    id: 6,
    title: 'membership_features_tags_title',
    body: 'membership_features_tags_body',
  },
  {
    id: 7,
    title: 'membership_features_bedtime_guidance_title',
    body: 'membership_features_bedtime_guidance_body',
  },
  {
    id: 8,
    title: 'membership_features_audio_sessions_title',
    body: 'membership_features_audio_sessions_body',
  },
  {
    id: 9,
    title: 'membership_features_track_movement_title',
    body: 'membership_features_track_movement_body',
  },
];
